var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            width: _vm.formData.width,
            modal: true,
            "close-on-click-modal": false,
            "custom-class": "person",
            "show-close": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "logo" }, [
              _c("img", { attrs: { src: _vm.rolesConfig.url, alt: "" } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "logo-text" }, [
              _vm._v(_vm._s(_vm.rolesConfig.name)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "logo-reason" }, [
              _vm._v(_vm._s(_vm.rolesConfig.reason)),
            ]),
            _vm._v(" "),
            _vm.rolesConfig.tab
              ? _c(
                  "div",
                  { staticClass: "w60", on: { click: _vm.handleTab } },
                  [
                    _c("el-button", { attrs: { type: "success" } }, [
                      _vm._v(_vm._s(_vm.$t("navbar.tabenterprise"))),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w60" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleConfirm },
                  },
                  [_vm._v(_vm._s(_vm.$t("setting.enterprise07")))]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }